import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ExtractionSchedulingRecipesChangesRoute } from '../../routing'

export  class ExtractionSchedulingRecipesChangesPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <ExtractionSchedulingRecipesChangesRoute />
          </Fragment>
        )
    }
}
